import { mapState, mapActions } from "vuex";
import moment from "moment";
import { asyncWait } from "@/utils";
import AppIcon from "@/components/AppIcon.vue";
import ContentMixin from "@/mixins/ContentMixin.vue";
import TasksMixin from "@/mixins/TasksMixin.vue";
import FileUploadErrorMessageMixin from "@/mixins/FileUploadErrorMessageMixin.vue";
import { EVENTS } from "@/utils";
import { CSV_EXPORT_ROW_LIMIT } from "@/utils/constants";
export default {
  name: "SeoBulkModal",
  mixins: [ContentMixin, TasksMixin, FileUploadErrorMessageMixin],
  components: {
    AppIcon
  },
  emits: ["close-bulk-modal"],
  props: {
    modelValue: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      selectedFile: null,
      fileName: "",
      loading: false,
      isDragging: false,
      errorMessage: "",
      inputKey: 0,
      csv_headers: {
        country_code: "country_code",
        parent_asin: "parent_asins",
        asin: "asin",
        sku: "sku",
        seller_id: "seller_id",
        marketplace_id: "marketplace_id",
        content_id: "content_id",
        product_name: "product_name",
        item_highlight: "item_highlight",
        bullet_point_1: "bullet_point_1",
        bullet_point_2: "bullet_point_2",
        bullet_point_3: "bullet_point_3",
        bullet_point_4: "bullet_point_4",
        bullet_point_5: "bullet_point_5",
        generic_keyword: "generic_keyword",
        product_description: "product_description",
        initial_product_name: "initial_product_name",
        initial_item_highlight: "initial_item_highlight",
        initial_bullet_point_1: "initial_bullet_point_1",
        initial_bullet_point_2: "initial_bullet_point_2",
        initial_bullet_point_3: "initial_bullet_point_3",
        initial_bullet_point_4: "initial_bullet_point_4",
        initial_bullet_point_5: "initial_bullet_point_5",
        initial_generic_keyword: "initial_generic_keyword",
        initial_product_description: "initial_product_description",
        initial_push_status: "initial_push_status"
      },
      sheet_generationTaskIdentifier: "",
      override_ProductTaskIdentifier: "",
      isDownloading: false,
      upload_finished: false
    };
  },
  computed: {
    ...mapState({
      products: state => state.content.list,
      perPage: state => state.content.perPage,
      total_count: state => state.content.total_count,
      current_workspace: state => state.workspace.current_workspace,
      me: state => state.auth.me
    }),
    modal: {
      get() {
        return this.modelValue;
      },
      set(val) {
        this.$emit("update:modelValue", val);
      }
    },
    selectedSellerAccountId() {
      return this.contentSellersListGet().slice(-1).pop();
    },
    csvValueForHeader() {
      return this.csv_headers;
    }
  },
  mounted() {
    //this.override_ProductTaskIdentifier = `${this.current_workspace?.workspace_id}_manual_override_all_update_task_${this.selectedSellerAccountId}`;
    //this.sheet_generationTaskIdentifier = `${this.current_workspace.workspace_id}_google_sheet_generation_${this.selectedSellerAccountId}`;
    //this.getAsyncUpdate(this.override_ProductTaskIdentifier);
  },
  methods: {
    ...mapActions(["contentCreateBulkGoogleSheet", "uploadBulkDataCSV"]),
    processContentItem(content) {
      const country = this.getCountry(content.marketplace_id);
      return {
        country_code: this.getCountryCode(country),
        parent_asins: content.parent_asins,
        asin: content.asin,
        sku: content.sku,
        content_id: content.content_id,
        seller_id: content.seller_id,
        marketplace_id: content.marketplace_id,
        product_name: content["omny_version"].product_name,
        item_highlight: content["omny_version"].item_highlight,
        bullet_point_1: content["omny_version"].bullet_point_1,
        bullet_point_2: content["omny_version"].bullet_point_2,
        bullet_point_3: content["omny_version"].bullet_point_3,
        bullet_point_4: content["omny_version"].bullet_point_4,
        bullet_point_5: content["omny_version"].bullet_point_5,
        generic_keyword: content["omny_version"].generic_keyword,
        product_description: content["omny_version"].product_description,
        initial_product_name: content["omny_version"].product_name,
        initial_item_highlight: content["omny_version"].item_highlight,
        initial_bullet_point_1: content["omny_version"].bullet_point_1,
        initial_bullet_point_2: content["omny_version"].bullet_point_2,
        initial_bullet_point_3: content["omny_version"].bullet_point_3,
        initial_bullet_point_4: content["omny_version"].bullet_point_4,
        initial_bullet_point_5: content["omny_version"].bullet_point_5,
        initial_generic_keyword: content["omny_version"].generic_keyword,
        initial_product_description: content["omny_version"].product_description,
        initial_push_status: content.push_status
      };
    },
    async generateContentCsvRows(page) {
      try {
        const allCsvRows = [];
        const valueFunctionMap = this.csvValueForHeader;
        const content = await this.contentGetByFilters({
          ...{
            page_limit: CSV_EXPORT_ROW_LIMIT,
            page_offset: page
          },
          ...this.contentFiltersSelectedGet()
        });
        this.throwIfError(content);

        // 3. Map filtered content list to CSV rows

        for (const item of content.data) {
          const processed_item = this.processContentItem(item);
          const csvRow = Object.fromEntries(Object.keys(this.csv_headers).map(fieldName => {
            const internalKey = this.csv_headers[fieldName];
            const valueFn = valueFunctionMap[internalKey];
            const value = processed_item[internalKey];
            return [fieldName, value];
          }));
          allCsvRows.push(csvRow);
        }
        // 4.return all csv rows
        return allCsvRows;
      } catch (error) {
        window.$bus.trigger("showDanger", {
          message: "Error downloading full inventory CSV: " + error,
          visible: true,
          delay: 10
        });
      }
    },
    async downloadBulkTemplate() {
      if (this.isDownloading) return;
      this.isDownloading = true;
      window.$bus.trigger("showSuccess", {
        message: "Generating Google Sheet ...  </br>This process can take up to a minute.",
        visible: true,
        delay: 5000
      });
      const totalPages = this.totalPagetoDownload();
      let page = 1;
      while (page <= totalPages) {
        //console.log("page");
        //console.log(page);
        //console.log("totalPages");
        //console.log(totalPages);

        const allCsvRows = await this.generateContentCsvRows(page);
        const sheetName = `content-bulk-edit_${this.current_workspace.workspace_name}_${this.me.email}_${moment().format("YYYY_MM_DD")}`;
        const chunkSize = 512 * 1024; // 1MB
        //const chunkSize = 350; //this is for testing to see if doesnt break the line
        const allCsvRowsSize = JSON.stringify(allCsvRows).length;
        const totalChunks = Math.ceil(allCsvRowsSize / chunkSize);
        let payload = {
          sheet_name: sheetName,
          sheet_type: "bulk",
          workspace_id: this.current_workspace.workspace_id,
          task_type: "google_sheet_generation",
          account_id: this.selectedSellerAccountId,
          total_chunks: totalChunks,
          page_index: page,
          total_pages: totalPages
        };
        let index = 0;
        let chunkIndex = 0;
        let currentSize = 0;
        let chunk = [];
        while (index < allCsvRows.length) {
          //console.log("index")
          //console.log(index)
          //console.log("allCsvRows")
          //console.log(allCsvRows)
          let csvRow = JSON.stringify(allCsvRows[index]);
          currentSize += csvRow.length;
          if (currentSize > chunkSize) {
            payload.chunk = chunk;
            payload.chunk_index = chunkIndex;
            let data = await this.contentCreateBulkGoogleSheet(payload);
            if (data) {
              if (data.task_id === `${this.current_workspace.workspace_id}_google_sheet_generation_${this.selectedSellerAccountId}`) {
                //console.log("[server has started running the google sheet process]");
                //this.sheet_generationTaskIdentifier = `${this.current_workspace.workspace_id}_google_sheet_generation_${this.selectedSellerAccountId}`;

                //console.log("sheet_generationTaskIdentifier", this.sheet_generationTaskIdentifier);

                this.executeTaskStatusHandler(data);
                this.checkTaskStatusPeriodically(this.sheet_generationTaskIdentifier);
              }
            }
            chunk = [];
            chunkIndex++;
            currentSize = 0;
          }
          chunk.push(allCsvRows[index]);
          index++;
        }
        if (chunk.length > 0 && chunkSize > 0) {
          payload.chunk = chunk;
          payload.chunk_index = chunkIndex;
          let data = await this.contentCreateBulkGoogleSheet(payload);
          //console.log("sheet_generationTaskIdentifier", `${this.current_workspace.workspace_id}_google_sheet_generation_${this.selectedSellerAccountId}`);
          if (data) {
            if (data.task_id === `${this.current_workspace.workspace_id}_google_sheet_generation_${this.selectedSellerAccountId}`) {
              //console.log("[server has started running the google sheet process]");
              this.sheet_generationTaskIdentifier = `${this.current_workspace.workspace_id}_google_sheet_generation_${this.selectedSellerAccountId}`;
              this.executeTaskStatusHandler(data);
              this.checkTaskStatusPeriodically(this.sheet_generationTaskIdentifier);
            }
          }
        }
        page++;
      }
      window.$bus.trigger(EVENTS.MIXPANEL_TRACK, {
        event_name: "userGeneratedBulkEditTemplate",
        properties: {}
      });
    },
    handleIdle(data) {
      let task_result = data?.task_result;
    },
    handleRunning(data) {
      if (this.isDownloading) {
        this.handleDownloadRunning();
      } else {
        this.handleUploadRunning(data);
      }
    },
    handleFailed(data) {
      if (this.isDownloading) {
        this.handleDownloadFailed(data);
      } else {
        this.handleUploadFailed(data);
      }
    },
    handleFinished(data) {
      if (this.isDownloading) {
        this.handleDownloadFinished(data);
      } else {
        this.handleUploadFinished(data);
      }
    },
    handleDownloadRunning() {
      this.checkTaskStatusPeriodically(this.sheet_generationTaskIdentifier);
    },
    handleDownloadFailed(data) {
      if (this.asyncUpdateInterval) {
        clearTimeout(this.asyncUpdateInterval);
        this.asyncUpdateInterval = null;
      }
      window.$bus.trigger("showDanger", {
        visible: true,
        message: "Google sheet generation Task failed \n" + data.task_result,
        delay: 5000 // Show alert less than 5 secs
      });
      this.isDownloading = false;
      throw new Error("Google sheet generation Task failed");
    },
    async handleDownloadFinished(data) {
      const result = data.task_result;
      //console.log("sheet link: ", result.sheet_link);

      if (this.asyncUpdateInterval) {
        clearTimeout(this.asyncUpdateInterval);
        this.asyncUpdateInterval = null;
      }
      window.$bus.trigger("showSuccess", {
        visible: true,
        message: "The google sheet has been successfully generated. A link has been sent to your email.",
        delay: 30000 // Show alert less than 30 secs
      });
      await asyncWait(6000);
      this.isDownloading = false;
      window.open(result.sheet_link, "_blank");
    },
    handleUploadRunning(data) {
      this.checkFileUploadTaskStatusPeriodically(data?.task_id);
    },
    handleUploadFailed(data) {
      this.selectedFile = null;
      if (this.asyncUpdateFileUpload) {
        clearTimeout(this.asyncUpdateFileUpload);
        this.asyncUpdateFileUpload = null;
      }
      //console.log("[handle failed message]");
      //console.log(data.task_result);

      let parsedFileUploadResponseError = this.parseFileUploadErrorResult(data.task_result);
      let errorSummary = "File Upload failed.Error Summary:<br>";
      Object.entries(parsedFileUploadResponseError.errorCount).forEach(([errorType, count]) => {
        errorSummary += `${errorType}: ${count} occurrence(s)<br>`;
      });
      const jsonData = JSON.stringify(parsedFileUploadResponseError, null, 2);
      const blob = new Blob([jsonData], {
        type: "application/json"
      });
      const url = URL.createObjectURL(blob);
      let download_link = `<a href="${url}" download="file_upload_errors.json" class="btn btn-link">Click here to download detailed report</a>`;
      window.$bus.trigger(EVENTS.MIXPANEL_TRACK, {
        event_name: "userFailedToBulkUpdateContent",
        properties: {}
      });
      window.$bus.trigger("showDanger", {
        visible: true,
        message: errorSummary,
        delay: 60000,
        isHtml: true,
        htmlContent: download_link
      });
      this.loading = false;
    },
    async handleUploadFinished(data) {
      //console.log("data", data);
      this.selectedFile = null;
      if (this.asyncUpdateFileUpload) {
        clearTimeout(this.asyncUpdateFileUpload);
        this.asyncUpdateFileUpload = null;
      }
      const jsonData = JSON.stringify(data.task_result, null, 2);
      //console.log("data.task_result", data.task_result);
      const blob = new Blob([jsonData], {
        type: "application/json"
      });
      const url = URL.createObjectURL(blob);
      let download_link = `<a href="${url}" download="file_upload_summary.json" class="btn btn-link">Click here to download detailed report</a>`;
      if (this.upload_finished) {
        this.loading = false;
        const status = data?.task_result?.status;
        let parsedStatus;
        try {
          parsedStatus = JSON.parse(status);
        } catch (error) {
          parsedStatus = status;
        }
        if (Array.isArray(parsedStatus) && parsedStatus.length > 0 && Object.keys(parsedStatus[0]).includes("error")) {
          window.$bus.trigger("showDanger", {
            visible: true,
            message: "Some listings could not be updated.",
            delay: 60,
            // Show alert less than 60 secs
            isHtml: true,
            htmlContent: download_link
          });
        } else {
          window.$bus.trigger("showSuccess", {
            visible: true,
            message: "Listings updated successfully",
            delay: 60,
            // Show alert less than 60 secs
            isHtml: true,
            htmlContent: download_link
          });
        }
        window.$bus.trigger(EVENTS.MIXPANEL_TRACK, {
          event_name: "userBulkUpdatedContentSuccessfully",
          properties: {}
        });
        await window.$bus.trigger(EVENTS.REFRESH_SEO_PAGE_CONTENT_TABLE);
        this.modal = false;
      }
    },
    triggerNativeFileInput() {
      //console.log("[trigger file input]");
      this.$refs.nativeFileInput.click();
    },
    async uploadSeoDataCSVFile() {
      const chunkSize = 1024 * 1024 * 5; // 5MB
      //const chunkSize = 350; //this is for testing to see if doesnt break the line
      const reader = new FileReader();
      const file = this.selectedFile;
      const totalChunks = Math.ceil(file.size / chunkSize);
      let payload = {
        fileName: file.name,
        fileType: file.type,
        totalChunks: totalChunks
      };
      this.loading = true;
      reader.onload = async event => {
        const fileContent = event.target.result;
        const lines = fileContent.split("\n");
        let lineIndex = 4; //Start from 5th line
        let chunkIndex = 0;
        let chunk = "";
        let line = "";
        let currentSize = 0;
        while (lineIndex < lines.length && this.loading) {
          line = lines[lineIndex];
          chunk += line + "\n";
          currentSize += line.length + 1;
          lineIndex++;
          if (currentSize > chunkSize) {
            payload.chunk = chunk;
            payload.chunkIndex = chunkIndex;
            let response = await this.uploadBulkDataCSV(payload);

            //console.log("[file process update in the sidebar>>Initial chunk]");
            this.checkFileUploadTaskStatusPeriodically(response.task_id);
            chunk = lines[4] + "\n";
            currentSize = 0;
            chunkIndex++;
          }
        }
        if (chunk.length > 0 && currentSize > 1 && this.loading) {
          payload.chunk = chunk;
          payload.chunkIndex = chunkIndex;
          let response = await this.uploadBulkDataCSV(payload);
          //console.log("[file process update in the sidebar>>Final chunk]");
          this.checkFileUploadTaskStatusPeriodically(response?.task_id);
        }
        this.upload_finished = true;
        reader.abort();
      };
      reader.readAsText(this.selectedFile);
      window.$bus.trigger("showSuccess", {
        message: "Uploading CSV File ...  ",
        visible: true,
        delay: 10
      });
    },
    handleFileChange(event) {
      const file = event.target.files[0];
      this.inputKey++;
      this.validateFile(file);
    },
    handleDragOver(event) {
      event.preventDefault();
      event.stopPropagation();
    },
    dragEnter() {
      this.isDragging = true;
      //console.log("Drag enter detected"); // Debugging
    },
    dragLeave() {
      this.isDragging = false;
      //console.log("Drag leave detected"); // Debugging
    },
    handleDrop(event) {
      const file = event.dataTransfer.files[0];
      //console.log("[handle drop]");
      //console.log(file);
      //console.log("[handle drop event]", event);
      //console.log("[event dataTransfer]", event.dataTransfer);
      this.validateFile(file);
      this.isDragging = false;
    },
    validateFile(file) {
      const validTypes = ["text/csv"];
      //console.log("validate file");
      //console.log("[dragged file to validate]");
      //console.log(file);
      if (file) {
        if (!validTypes.includes(file.type)) {
          this.errorMessage = "The submitted file is not supported.";
          this.selectedFile = null;
        } else {
          this.errorMessage = null;
          this.selectedFile = file;
          this.fileName = this.selectedFile.name;
          this.loading = true;
          //console.log("[selected file:]", this.selectedFile);
          this.uploadSeoDataCSVFile();
        }
      } else {
        this.errorMessage = "No files were dropped.";
      }
    }
  }
};